import AgChartsGraphGrid from "./AgChartsGraphGrid";
import AnalyticsMermaidDiagramCard from "./components/Mermaid/AnalyticsMermaidDiagramCard";

import type {
  AnalyticsGraphArtifact,
  AnalyticsGraphToolChartData,
} from "@/queries/analytics-custom-charts-types";
import { AnalyticsGraphFormat } from "@/queries/analytics-custom-charts-types";
import { cn } from "@/lib/utils";

interface AnalyticsGraphChartsGridProps {
  artifact: AnalyticsGraphArtifact;
  compact?: boolean;
  className?: string;
  onChartDataChange?: (chartData: AnalyticsGraphToolChartData) => void;
}

const AnalyticsGraphChartsGrid = ({
  artifact,
  compact = false,
  className,
  onChartDataChange,
}: AnalyticsGraphChartsGridProps) => {
  if (artifact.format === AnalyticsGraphFormat.Mermaid) {
    return (
      <AnalyticsMermaidDiagramCard
        title={artifact.title}
        diagram={artifact.diagram}
        className={cn("w-full", className)}
      />
    );
  }

  return (
    <AgChartsGraphGrid
      artifact={artifact}
      compact={compact}
      className={className}
      onChartDataChange={onChartDataChange}
    />
  );
};

export default AnalyticsGraphChartsGrid;
